<div class="ui icon message message-container">
    <div class="content">
        <div class="blue header">Suggested Times</div>
        <p class="content__body">
            Here are some times everyone is available. Select an option to send out the invites.
        </p>
        <div class="ui form">
            <div class="grouped fields reduced-width">
                <div
                    *ngFor="let suggestedTime of suggestedTimes | slice: 0:4"
                    zoom-date-time-checkbox
                    [dateTime]="suggestedTime"
                    [selectedTimeStart]="selectedTimeStart"
                    (onSelectTime)="handleSelectTime($event)"
                ></div>
                <button
                    (click)="onViewMore()"
                    *ngIf="!viewMore && suggestedTimes && suggestedTimes.length > 4"
                    class="ui button view-more"
                >
                    <i class="ui icon arrow circle down"></i> View more times
                </button>
                <ng-container *ngIf="viewMore">
                    <div
                        *ngFor="let suggestedTime of suggestedTimes | slice: 4:10"
                        zoom-date-time-checkbox
                        [dateTime]="suggestedTime"
                        [selectedTimeStart]="selectedTimeStart"
                        (onSelectTime)="handleSelectTime($event)"
                    ></div>
                </ng-container>
                <div
                    class="field suggested-time-field"
                    [ngClass]="{ 'selected-checkbox': selectedTimeStart === 'let-them-decide' }"
                >
                    <div class="ui radio checkbox" (click)="handleSelectLetThemDecide('let-them-decide')">
                        <input type="radio" name="suggestedTime" [checked]="selectedTimeStart === 'let-them-decide'" />
                        <label>Let them decide!</label>
                    </div>
                </div>
            </div>
        </div>
        <ng-container *ngIf="timezone">
            <p class="timezone">All times shown in {{ timezone | tzName }}</p>
        </ng-container>
    </div>
    <img class="ui medium image" src="/assets/images/time-selection.svg" />
</div>
